<template>
  <div class="home-menu row">
    <div v-for="(item, index) of menu" :key="index" class="home-menu-item link-content">
      <a :href="item.url">{{ item.title }}</a>
    </div>
  </div>
</template>


<script>
export default {
  name: "fcwpAdjacent",
  props: ["menu"]
};
</script>

<style lang="scss">
.home-menu {
  .home-menu-item {
    margin: 0 auto;
    a:after {
      content: " >";
      color: rgb($secondary-color);
    }
  }
}

@media (min-width: 1200px) {
  .home-menu {
    text-align: center;
    padding: 7rem 6vw 7rem 6vw;
    .link-content {
      font-size: 2.5vw;
      :before {
        margin-right: 0.3vw;
        margin-left: 1.75vw;
      }
      :hover::before {
        top: -3px;
        margin-right: 0.3vw;
        margin-left: 0vw;
      }
    }
  }
}

@media (max-width: 1199px) {
  .home-menu {
    padding: 7rem 3vw 7rem 3vw;
  }
}

@media (max-width: 768px) {
  .home-menu {
    text-align: left;
    display: block !important;
    padding: 3rem 1rem;
  }
}
</style>
